<template>
  <input
    :id="id"
    :type="type"
    :value="value"
    :placeholder="placeholder"
    :disabled="disabled"
    :readonly="readonly"
    :class="inputClasses"
    :aria-invalid="ariaInvalid"
    :aria-describedby="ariaDescribedby"
    :aria-required="ariaRequired"
    v-bind="$attrs"
    @input="handleInput"
    @blur="$emit('blur', $event)"
    @focus="$emit('focus', $event)"
  />
</template>

<script>
export default {
  name: 'ThemedInput',
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'text',
      validator: (value) => [
        'text', 'email', 'password', 'number', 
        'tel', 'url', 'search', 'date', 'time',
        'datetime-local', 'month', 'week'
      ].includes(value)
    },
    value: {
      type: [String, Number],
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    success: {
      type: Boolean,
      default: false
    },
    ariaInvalid: {
      type: String,
      default: null
    },
    ariaDescribedby: {
      type: String,
      default: null
    },
    ariaRequired: {
      type: String,
      default: null
    }
  },
  computed: {
    inputClasses() {
      const baseClasses = 'flex h-9 w-full rounded-md border px-3 py-1 text-sm transition-all outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50';
      
      const stateClasses = [];
      
      // Background and border
      if (this.readonly) {
        stateClasses.push('bg-muted cursor-default');
      } else {
        stateClasses.push('bg-input-background border-input');
      }
      
      // Focus states
      if (!this.error && !this.success) {
        stateClasses.push('focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/50');
      }
      
      // Error state
      if (this.error) {
        stateClasses.push('border-destructive focus-visible:border-destructive focus-visible:ring-2 focus-visible:ring-destructive/20');
      }
      
      // Success state
      if (this.success) {
        stateClasses.push('border-primary focus-visible:border-primary focus-visible:ring-2 focus-visible:ring-primary/20');
      }
      
      return this.cn(baseClasses, ...stateClasses);
    }
  },
  methods: {
    handleInput(event) {
      this.$emit('input', event.target.value);
    }
  }
}
</script>
